import { render, staticRenderFns } from "./GradeSubmission.vue?vue&type=template&id=1effe9ca&scoped=true"
import script from "./GradeSubmission.vue?vue&type=script&lang=js"
export * from "./GradeSubmission.vue?vue&type=script&lang=js"
import style0 from "./GradeSubmission.vue?vue&type=style&index=0&id=1effe9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1effe9ca",
  null
  
)

export default component.exports